import '../../App.css';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import { useState, useEffect, useRef } from 'react';
import React from 'react';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import '@fortawesome/fontawesome-free/css/all.min.css';

import { Modal, Button } from 'react-bootstrap'; // Ensure Button and Modal are imported

import * as Icon from 'react-feather';
import MainStructure from '../../components/general/MainStructure';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import ImageUploader from '../ImageUploader';
import LoadingIndicator from '../../components/general/LoadingIndicator';
import { toast } from 'react-toastify';

import ximage from "../../assets/twitter.png"
import linkedinimage from "../../assets/linkedin.png"
import youtubeimage from "../../assets/youtube.png"
import instagramimage  from "../../assets/instagram.png"

import threadsimage  from "../../assets/threads.png"
import facebook  from "../../assets/facebook.png"
import tiktokimage  from "../../assets/tiktok.png"
import blueskyimage  from "../../assets/bluesky.png"
import discordimage  from "../../assets/discord.png"
import pinterestimage from "../../assets/pinterest.png"
import skoolimage from "../../assets/skool.png"
import { useSkoolTargets, SkoolTargetRows, SKOOL_TITLE_MAX } from '../../components/skool/SkoolTargets';
import TimezoneSelector from '../components/TimezoneSelector';
import Spinner from 'react-bootstrap/Spinner';
import VideoUploader from '../VideoUploader';
import MediaPicker from '../MediaPicker';
import PostStats from '../../components/analytics/PostStats';


const PostPreview = ({ content, uploadedImages, uploadedVideos, shortText, title }) => {
    return (
        <div className="preview-stage mb-4" style={{ background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)', padding: '25px 15px', borderRadius: '15px', border: '1px solid #dee2e6', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div className="d-flex align-items-center mb-3 w-100 justify-content-center">
                <span className="badge bg-primary px-3 py-2 shadow-sm" style={{ borderRadius: '20px', fontSize: '0.7rem', letterSpacing: '0.5px' }}>
                    <i className="fas fa-eye me-2"></i> LIVE PREVIEW
                </span>
            </div>

            <div className="card shadow-lg w-100" style={{ maxWidth: '400px', borderRadius: '12px', overflow: 'hidden', border: 'none', backgroundColor: '#ffffff' }}>
                <div className="card-body p-3">
                    <div className="d-flex align-items-center mb-3">
                        <div className="rounded-circle bg-primary d-flex align-items-center justify-content-center me-2 text-white" style={{ width: '40px', height: '40px' }}>
                            <i className="fas fa-smile"></i>
                        </div>
                        <div>
                            <div className="fw-bold mb-0" style={{ fontSize: '0.9rem', color: '#050505' }}>Preview Profile</div>
                            <div className="text-muted small" style={{ fontSize: '0.75rem' }}>Now · <Icon.Globe size={10} /></div>
                        </div>
                    </div>

                    {title && (
                        <div className="fw-bold mb-1" style={{ fontSize: '1rem', color: '#050505' }}>{title}</div>
                    )}
                    <div className="post-content mb-3" style={{ fontSize: '0.9rem', whiteSpace: 'pre-wrap', color: '#1c1e21', lineHeight: '1.4' }}>
                        {content || <span className="text-muted italic">No content yet...</span>}
                    </div>

                    {uploadedImages?.length > 0 && (
                        <div className="position-relative mb-2 rounded overflow-hidden" style={{ border: '1px solid #f0f2f5' }}>
                            <img
                                src={typeof uploadedImages[0] === 'string' ? uploadedImages[0] : (uploadedImages[0].url || uploadedImages[0])}
                                alt="Preview"
                                style={{ width: '100%', height: 'auto', maxHeight: '250px', objectFit: 'cover' }}
                            />
                            {uploadedImages.length > 1 && (
                                <div className="position-absolute bottom-0 end-0 m-2 badge bg-dark opacity-75">
                                    +{uploadedImages.length - 1} more
                                </div>
                            )}
                        </div>
                    )}

                    {uploadedVideos?.length > 0 && (
                        <div className="mb-2 rounded overflow-hidden bg-dark shadow-sm" style={{ border: '1px solid #f0f2f5' }}>
                            <video
                                controls
                                style={{ width: '100%', maxHeight: '350px', display: 'block' }}
                                src={
  typeof uploadedVideos[0] === 'string'
    ? uploadedVideos[0]
    : (uploadedVideos[0].file_url || uploadedVideos[0].url || (uploadedVideos[0] instanceof Blob ? URL.createObjectURL(uploadedVideos[0]) : ""))
}
                            >
                                Your browser does not support the video tag.
                            </video>
                            {shortText && (
                                <div className="bg-white p-2 border-top">
                                    <div className="fw-bold small text-truncate" style={{ color: '#050505' }}>{shortText}</div>
                                </div>
                            )}
                        </div>
                    )}

                    <div className="d-flex justify-content-between text-muted mt-3 pt-3 border-top" style={{ fontSize: '0.8rem' }}>
                        <span className="d-flex align-items-center"><Icon.Heart size={14} className="me-1" /> Like</span>
                        <span className="d-flex align-items-center"><Icon.MessageCircle size={14} className="me-1" /> Comment</span>
                        <span className="d-flex align-items-center"><Icon.Share2 size={14} className="me-1" /> Share</span>
                    </div>
                </div>
            </div>
        </div>
    );
};


function AccountAvatar({ src, name, size = 36 }) {
  const [failed, setFailed] = useState(false);
  const letter = (typeof name === 'string' && name ? name[0] : '?').toUpperCase();
  const colors = ['#e0f2fe','#dcfce7','#fef9c3','#fce7f3','#ede9fe','#ffedd5'];
  const textColors = ['#0369a1','#15803d','#a16207','#9d174d','#6d28d9','#c2410c'];
  const idx = Math.abs((letter.charCodeAt(0) || 65) - 65) % colors.length;
  if (failed || !src) {
    return (
      <div style={{
        width: size, height: size, borderRadius: '50%', flexShrink: 0,
        background: colors[idx], display: 'flex', alignItems: 'center',
        justifyContent: 'center', fontSize: size * 0.4, fontWeight: 700, color: textColors[idx],
      }}>
        {letter}
      </div>
    );
  }
  return (
    <img src={src} alt={name}
      style={{ width: size, height: size, borderRadius: '50%', display: 'block', objectFit: 'cover', flexShrink: 0 }}
      onError={() => setFailed(true)}
    />
  );
}

function SinglePost() {
  const { postId } = useParams();
  const navigate = useNavigate();
  const { jwtToken } = useAuth(); // Assuming jwtToken is stored in your auth context

    const [showMediaPicker, setShowMediaPicker] = useState(false);

  const formatLocalDate = (date) => {
  const pad = (num) => String(num).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};

const [postStatus, setPostStatus] = useState('publish');
const [uploadedVideos, setUploadedVideos] = useState([]);

// ── Approval workflow ─────────────────────────────────────────────────────
const [requireApproval, setRequireApproval]       = useState(false);
const [approvalEmail, setApprovalEmail]           = useState('');
const [emailSuggestions, setEmailSuggestions]     = useState([]);
const [showEmailSuggestions, setShowEmailSuggestions] = useState(false);
const suggestionTimer = useRef(null);

const [showTrashModal, setShowTrashModal] = useState(false);
  const [isTrashing, setIsTrashing] = useState(false);

        const [selectedAccounts, setSelectedAccounts] = useState([]);
        // Active platform filter for the "Post To" list: clicking a platform icon
        // shows ONLY that platform's accounts; clicking it again shows all.
        // '' = no filter. linkedin_page is grouped under linkedin.
        const [typeFilter, setTypeFilter] = useState('');
const [shortText, setShortText] = useState('');
        const [timezone, setTimezone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone);

  const myContext = useAuth();
  const mySocialAccounts = myContext.accounts || [];

  // Skool posts carry a title, group and category in their own tables
  // (lib/skool.php), edited here with the same picker as the Skool composer.
  const skool = useSkoolTargets(myContext.getAccountsData);
  const skoolRef = useRef(skool);   // the fetch effect runs once per post, so it reads the latest helpers from here
  skoolRef.current = skool;
  const [skoolTitle, setSkoolTitle] = useState('');
  const skoolAccounts = mySocialAccounts.filter(a => a.type === 'skool');
  // Everywhere else Skool accounts are left out: a Skool post needs its group
  // and category, which the general account list can't set.
  const listAccounts = mySocialAccounts.filter(a => a.type !== 'skool');

  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loading2, setLoading2] = useState(false);
  const [error, setError] = useState(null);

  const [uploadedImages, setUploadedImages] = useState([]);

  function generateRandomString(length = 10) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}


  const [content, setContent] = useState('');

// X/Twitter reply thread ("first comment") — ordered list of reply tweets
const [replies, setReplies] = useState([]);
const addReply    = () => setReplies(prev => [...prev, '']);
const updateReply = (i, val) => setReplies(prev => prev.map((r, idx) => idx === i ? val : r));
const removeReply = (i) => setReplies(prev => prev.filter((_, idx) => idx !== i));
const isTwitterSelected = selectedAccounts.some(v => v.split('_')[1] === 'twitter');
const isSkoolPost = !!(post && post.skool);
useEffect(() => {
  if (isSkoolPost) setSelectedAccounts(Object.keys(skool.targets).map(id => `${id}_skool`));
}, [isSkoolPost, skool.targets]);

const [isDuplicating, setIsDuplicating] = useState(false);

  async function handleMoveToTrash() {
    setIsTrashing(true);
    try {
      const response = await fetch('https://api.schedpilot.com/wp-json/api/v1/deleteScheduledPost', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          postId: postId
        })
      });

      const data = await response.json();

      if (response.ok) {
        myContext.setJWTLocal(); // Refresh accounts data to reflect changes in scheduled posts count
        toast.success("Post moved to trash successfully!");
        navigate('/dashboard'); // Redirect to dashboard or calendar after deletion
      } else {
        toast.error(data.message || "Failed to move post to trash.");
      }
    } catch (error) {
      console.error('Error trashing post:', error);
      toast.error("A network error occurred.");
    } finally {
      setIsTrashing(false);
      setShowTrashModal(false);
    }
  }



  const handleContentChange = (e) => {
    setContent(e.target.value);
  };


  const [selectedDate, setSelectedDate] = useState(new Date());
  const handleDateChange = date => setSelectedDate(date);


function formatUtcToLocalTime(utcDateTimeString) {
  if (!utcDateTimeString) return new Date(); // Return current time if missing

  // Convert to Date object, treating input as UTC
  const utcDate = new Date(utcDateTimeString + 'Z');

  // Check if the date is valid, otherwise return current date
  return isNaN(utcDate.getTime()) ? new Date() : utcDate;
}

const displaySelectedAccounts = selectedAccounts.map(idType => {
  const underscore = idType.indexOf('_');
  const id   = idType.slice(0, underscore);
  const type = idType.slice(underscore + 1);
  return mySocialAccounts.find(acc =>
    acc.id.toString() === id &&
    acc.type === type
  );
}).filter(Boolean);



 const removeImage = (indexToRemove) => {
  setUploadedImages(prev => prev.filter((_, index) => index !== indexToRemove));
};

const removeVideo = (indexToRemove) => {
  setUploadedVideos(prev => prev.filter((_, index) => index !== indexToRemove));
};

// Skool's own fields (title, images, group, category) are saved first through
// update-skool-post; the shared updatePost then saves the text, date, status
// and accounts. Returns false, after telling the user why, if it can't save.
async function saveSkoolParts() {
  if (!isSkoolPost) return true;
  const problems = [];
  if (!skoolTitle.trim()) problems.push('Add a title');
  if (skoolTitle.length > SKOOL_TITLE_MAX) problems.push(`Shorten the title to ${SKOOL_TITLE_MAX} characters`);
  problems.push(...skool.problems(skoolAccounts));
  if (problems.length) {
    toast.error(problems[0]);
    return false;
  }
  try {
    const res = await fetch('https://api.schedpilot.com/wp-json/api/v1/update-skool-post', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        postId,
        title: skoolTitle.trim(),
        images: uploadedImages.map(img => (typeof img === 'object' ? img.id : img)),
        targets: skool.targetList(skoolAccounts),
      }),
    });
    const data = await res.json().catch(() => ({}));
    if (data.code !== 200) {
      toast.error(data.message || 'Could not save the Skool settings.');
      return false;
    }
    return true;
  } catch (e) {
    toast.error('A network error occurred.');
    return false;
  }
}

async function updateMyPost() {
  if (selectedAccounts.length === 0) {
    toast.error("Please select at least one account.");
    return;
  }

  setLoading2(true);
  if (!(await saveSkoolParts())) { setLoading2(false); return; }
  try {
    const response = await fetch('https://api.schedpilot.com/wp-json/api/v1/updatePost', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
  postId: postId,
  scheduledDate: formatLocalDate(selectedDate),
  timezone: timezone,
  content: content,
  postStatus: postStatus,
  videoTitle: shortText, // Add this
  images: uploadedImages,
  videos: uploadedVideos,
  accounts: selectedAccounts,
  replies: replies
})
    });

    const data = await response.json();

    if (response.ok) {
      toast.success("Post updated successfully!");
    } else {
      toast.error(data.message || "Update failed.");
    }
  } catch (error) {
    console.error('Error updating post:', error);
    toast.error("A network error occurred.");
  } finally {
    setLoading2(false);
  }
}



  // ── Approval helpers ────────────────────────────────────────────────────
  const fetchEmailSuggestions = async (q) => {
    if (q.length < 2) { setEmailSuggestions([]); return; }
    try {
      const res = await fetch(
        `https://api.schedpilot.com/wp-json/api/v1/approval-email-suggestions?q=${encodeURIComponent(q)}`,
        { credentials: 'include' }
      ).then(r => r.json());
      setEmailSuggestions(res.emails || []);
      setShowEmailSuggestions((res.emails || []).length > 0);
    } catch { setEmailSuggestions([]); }
  };

  const handleApprovalEmailChange = (val) => {
    setApprovalEmail(val);
    clearTimeout(suggestionTimer.current);
    suggestionTimer.current = setTimeout(() => fetchEmailSuggestions(val), 300);
  };

  const handleSendForApproval = async () => {
    if (!approvalEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(approvalEmail)) {
      toast.error('Please enter a valid client email address.');
      return;
    }
    if (selectedAccounts.length === 0) {
      toast.error('Please select at least one account.');
      return;
    }
    setLoading2(true);
    if (!(await saveSkoolParts())) { setLoading2(false); return; }
    try {
      const res = await fetch('https://api.schedpilot.com/wp-json/api/v1/updatePost', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          postId,
          scheduledDate: formatLocalDate(selectedDate),
          timezone,
          content,
          postStatus: 'pending_approval',
          approvalEmail,
          videoTitle: shortText,
          images: uploadedImages,
          videos: uploadedVideos,
          accounts: selectedAccounts,
          replies: replies,
        }),
      });
      const data = await res.json();
      if (res.ok && data.code === 200) {
        setPostStatus('pending_approval');
        setRequireApproval(false);
        toast.success(`Approval request sent to ${approvalEmail}!`);
      } else {
        toast.error(data.message || 'Failed to send approval request.');
      }
    } catch {
      toast.error('A network error occurred.');
    } finally {
      setLoading2(false);
    }
  };

  useEffect(() => {
       setLoading(true);

    const fetchPost = async () => {
      try {
        // Get JWT token (from localStorage or context)
        const tokenFromLocalStorage = await new Promise((resolve) => {
          resolve(localStorage.getItem('jwtToken'));
        });

        const response = await fetch(
          `https://api.schedpilot.com/wp-json/api/v1/getSinglePost?id=${postId}` + "&rnd=" + generateRandomString(),
          {
            method: 'GET',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            }
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const json = await response.json();

        if (json.code === 200) {
          setPost(json.post);
          setUploadedImages(json.post.images)
          setUploadedVideos(json.post.videos || []); // Set videos here

          setPostStatus(json.post.post_status || 'publish');
          if (json.post.post_status === 'pending_approval') setRequireApproval(true);
          if (json.post.approval_email) setApprovalEmail(json.post.approval_email);

         let localAccounts = json.post.accounts.map((accItem) => {

              return accItem.id + "_" + accItem.type;
            });


          setSelectedAccounts(localAccounts)

          if (json.post.timezone) {
            setTimezone(json.post.timezone);
          }


        const mytime = formatUtcToLocalTime(json.post.scheduled_date);
        console.log(mytime)

         if (json.post.scheduled_date_original) {
            setSelectedDate(new Date(json.post.scheduled_date_original.replace(' ', 'T')));
          } else {
            // Fallback for older posts using old UTC conversion
            setSelectedDate(new Date(json.post.scheduled_date + 'Z'));
          }

          setContent(json.post.content)
          setShortText(json.post.videoTitle || '');
          if (json.post.skool) {
            setSkoolTitle(json.post.skool.title || '');
            skoolRef.current.loadTargets(json.post.skool.targets);
          }
          setReplies(Array.isArray(json.post.replies) ? json.post.replies : []);


          if (json.post.timezone) {
                setTimezone(json.post.timezone);
            }

            // 2. Handle Date Selection (The fix)
            if (json.post.scheduled_date_original) {
                // Try to use the original display date
                setSelectedDate(new Date(json.post.scheduled_date_original.replace(' ', 'T')));
            } else if (json.post.scheduled_date) {
                // Fallback to UTC date if original is missing
                setSelectedDate(new Date(json.post.scheduled_date + 'Z'));
            } else {
                // If it's a draft with NO date, use CURRENT date/time
                setSelectedDate(new Date());
            }


        } else {
          throw new Error(json.message || 'Post not found');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, [postId]);


async function handleDuplicate(id) {
  setIsDuplicating(true);
  const toastId = toast.loading("Duplicating post...");

  try {
    const response = await fetch('https://api.schedpilot.com/wp-json/api/v1/duplicatePost', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id: id })
    });

    const data = await response.json();

    if (response.ok && data.code === 200) {
      toast.update(toastId, {
        render: "Post duplicated! Redirecting...",
        type: "success",
        isLoading: false,
        autoClose: 2000
      });

      // Redirect to the same component but with the NEW ID
      // This assumes your route is /post/:postId. Adjust the path if it's different.
      navigate(`/single-post/${data.data.new_id}`);
    } else {
      toast.update(toastId, {
        render: data.error || "Failed to duplicate post.",
        type: "error",
        isLoading: false,
        autoClose: 3000
      });
    }
  } catch (error) {
    console.error('Error duplicating post:', error);
    toast.update(toastId, {
      render: "A network error occurred.",
      type: "error",
      isLoading: false,
      autoClose: 3000
    });
  } finally {
    setIsDuplicating(false);
  }
}

  // ── Shared style helpers ──────────────────────────────────────────────────
  const platformIcons = {
    twitter: ximage,
    linkedin: linkedinimage,
    linkedin_page: linkedinimage,
    youtube: youtubeimage,
    instagram: instagramimage,
    threads: threadsimage,
    facebook: facebook,
    tiktok: tiktokimage,
    bluesky: blueskyimage,
    pinterest: pinterestimage,
    discord: discordimage,
    skool: skoolimage,
  };

  const sectionLabelStyle = {
    fontSize: '0.75rem',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    color: '#64748b',
    marginBottom: 6,
    display: 'block',
  };

  const cardStyle = {
    background: '#fff',
    border: '1px solid #e8edf2',
    borderRadius: 12,
    marginBottom: 16,
  };

  return (
    <MainStructure activeItem="single-post">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          {error ? (
            <div>Error</div>
          ) : (
            <div className="container-fluid p-0">

              {/* ── Header ── */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="d-flex align-items-center gap-3">
                  <button
                    className="btn btn-outline-secondary btn-sm d-flex align-items-center"
                    onClick={() => navigate(-1)}
                    title="Go back"
                  >
                    <Icon.ArrowLeft size={15} className="me-1" />
                    Back
                  </button>
                  <div>
                    <div className="d-flex align-items-center gap-2">
                      <h1 className="h5 mb-0" style={{ fontWeight: 800 }}>
                        {(() => {
                          const heading = (isSkoolPost && skoolTitle) || shortText || post.content || '';
                          return heading.length > 40 ? heading.substring(0, 40) + '…' : heading;
                        })()}
                      </h1>
                      {postStatus === 'publish' ? (
                        <span style={{ fontSize: '0.7rem', fontWeight: 700, padding: '2px 10px', borderRadius: 20, background: '#dcfce7', color: '#16a34a' }}>
                          Scheduled
                        </span>
                      ) : postStatus === 'pending_approval' ? (
                        <span style={{ fontSize: '0.7rem', fontWeight: 700, padding: '2px 10px', borderRadius: 20, background: '#fef3c7', color: '#d97706' }}>
                          Pending Approval
                        </span>
                      ) : (
                        <span style={{ fontSize: '0.7rem', fontWeight: 700, padding: '2px 10px', borderRadius: 20, background: '#f1f5f9', color: '#64748b' }}>
                          Draft
                        </span>
                      )}
                    </div>
                    <p className="mb-0 text-muted" style={{ fontSize: '0.82rem' }}>Edit, view or delete this post.</p>
                  </div>
                </div>
                <button
                  className="btn btn-outline-secondary btn-sm d-flex align-items-center"
                  onClick={() => handleDuplicate(post.id)}
                  disabled={isDuplicating}
                  title="Duplicate Post"
                >
                  {isDuplicating ? (
                    <Spinner size="sm" className="me-2" />
                  ) : (
                    <Icon.Copy size={15} className="me-1" />
                  )}
                  {isDuplicating ? 'Duplicating...' : 'Duplicate'}
                </button>
              </div>

              {/* ── 3-column layout ── */}
              <div className="row g-3">

                {/* ── Col 1: Content Editor ── */}
                <div className="col-12 col-md-4">
                  <div style={cardStyle} className="p-3">

                    {isSkoolPost && (
                      <div className="mb-3">
                        <label style={sectionLabelStyle}>Title</label>
                        <input
                          type="text"
                          className="form-control"
                          maxLength={SKOOL_TITLE_MAX + 20}
                          value={skoolTitle}
                          placeholder="Skool posts need a title"
                          onChange={(e) => setSkoolTitle(e.target.value)}
                        />
                        <div style={{ textAlign: 'right', fontSize: '0.75rem', color: skoolTitle.length > SKOOL_TITLE_MAX ? '#ef4444' : '#94a3b8', marginTop: 4 }}>
                          {skoolTitle.length}/{SKOOL_TITLE_MAX} chars
                        </div>
                      </div>
                    )}

                    {uploadedVideos.length > 0 && !isSkoolPost && (
                      <div className="mb-3">
                        <label style={sectionLabelStyle}>Video Title</label>
                        <textarea
                          className="form-control"
                          maxLength={100}
                          style={{ minHeight: 60 }}
                          value={shortText}
                          placeholder="Enter a title for the video..."
                          onChange={(e) => setShortText(e.target.value)}
                        />
                        <div style={{ textAlign: 'right', fontSize: '0.75rem', color: shortText.length >= 100 ? '#ef4444' : shortText.length >= 90 ? '#b45309' : '#94a3b8', marginTop: 4 }}>
                          {shortText.length}/100 chars
                        </div>
                      </div>
                    )}

                    <div className="mb-1">
                      <label style={sectionLabelStyle}>Content</label>
                      <textarea
                        style={{ width: '100%', height: 250 }}
                        className="form-control"
                        value={content}
                        onChange={handleContentChange}
                      />
                      <div style={{ textAlign: 'right', fontSize: '0.75rem', color: '#94a3b8', marginTop: 4 }}>
                        {content.length} chars
                      </div>
                    </div>

                    {isTwitterSelected && (
                      <div className="mt-3 p-3" style={{ border: '1px solid #e2e8f0', borderRadius: 12, background: '#f8fafc' }}>
                        <label style={sectionLabelStyle}>X / Twitter thread</label>
                        <p className="small text-muted mb-2">
                          Posted as replies after the main tweet (your “first comment”).
                        </p>

                        {replies.map((rep, i) => (
                          <div key={i} className="mb-2">
                            <div className="d-flex align-items-start" style={{ gap: 8 }}>
                              <span className="text-muted small" style={{ marginTop: 8, minWidth: 16 }}>{i + 1}.</span>
                              <textarea
                                className="form-control"
                                maxLength={280}
                                style={{ minHeight: 60 }}
                                value={rep}
                                placeholder={`Reply tweet ${i + 1}...`}
                                onChange={(e) => updateReply(i, e.target.value)}
                              />
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-danger"
                                style={{ marginTop: 2 }}
                                onClick={() => removeReply(i)}
                                title="Remove reply"
                              >
                                <Icon.X size={14} />
                              </button>
                            </div>
                            <div className="text-muted small text-right">{rep.length}/280 characters</div>
                          </div>
                        ))}

                        <button type="button" className="btn btn-sm btn-outline-primary" onClick={addReply}>
                          <Icon.Plus size={14} className="me-1" /> Add reply tweet
                        </button>
                      </div>
                    )}

                    <div className="mt-3">
                      <label style={sectionLabelStyle}>Images</label>
                      <ImageUploader
                        removeUploadedImages={removeImage}
                        uploadedImages={uploadedImages}
                        setUploadedImages={setUploadedImages}
                      />
                    </div>

                    {!isSkoolPost && (<>
                    <div className="mt-3">
                      <label style={sectionLabelStyle}>Videos</label>
                      <VideoUploader
                        uploadedVideos={uploadedVideos}
                        removeUploadedVideos={removeVideo}
                        setUploadedVideos={setUploadedVideos}
                      />
                    </div>

                    <div className="mt-2">
                      <Button variant="outline-secondary" size="sm" onClick={() => setShowMediaPicker(true)}>
                        <Icon.Database size={14} className="me-1" /> Choose from Media Library
                      </Button>
                    </div>

                    <MediaPicker
                      show={showMediaPicker}
                      onHide={() => setShowMediaPicker(false)}
                      type="videos"
                      onSelect={(video) => {
                        const isDuplicate = uploadedVideos.find(v =>
                          (v.id && v.id === video.id) ||
                          (typeof v === 'string' && v === video.file_url)
                        );
                        if (!isDuplicate) {
                          setUploadedVideos([...uploadedVideos, video]);
                          toast.success('Video added from library!');
                        } else {
                          toast.info('This video is already attached.');
                        }
                        setShowMediaPicker(false);
                      }}
                    />
                    </>)}

                  </div>
                </div>

                {/* ── Col 2: Accounts + Scheduling ── */}
                <div className="col-12 col-md-4">

                  {/* Selected accounts summary */}
                  {displaySelectedAccounts.length > 0 && (
                    <div style={{ ...cardStyle, padding: '10px 12px' }}>
                      <div className="d-flex align-items-center justify-content-between">
                        <label style={{ ...sectionLabelStyle, marginBottom: 6 }}>
                          Currently Selected ({displaySelectedAccounts.length})
                        </label>
                        <button
                          type="button"
                          onClick={() => setSelectedAccounts([])}
                          title="Unselect all accounts"
                          style={{
                            background: 'transparent',
                            border: 'none',
                            color: '#ef4444',
                            fontSize: '0.72rem',
                            fontWeight: 700,
                            cursor: 'pointer',
                            padding: '0 2px',
                            marginBottom: 6,
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 3,
                          }}
                        >
                          <Icon.X size={12} /> Clear all
                        </button>
                      </div>
                      <div className="d-flex flex-wrap gap-2">
                        {displaySelectedAccounts.map((account) => (
                          <div
                            key={account.id}
                            className="position-relative d-inline-block"
                            title={account.name}
                          >
                            <AccountAvatar src={account.image} name={account.name} size={44} />
                            {platformIcons[account.type] && (
                              <div className="position-absolute" style={{ bottom: -2, right: -2 }}>
                                <img
                                  src={platformIcons[account.type]}
                                  alt={account.type}
                                  style={{ height: 20, width: 20, borderRadius: '50%', background: '#fff', padding: 1 }}
                                />
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Account list card */}
                  <div style={cardStyle}>
                    <div className="p-3">
                      <label style={sectionLabelStyle}>Post To</label>

                      {isSkoolPost ? (
                        <SkoolTargetRows accounts={skoolAccounts} skool={skool} onConnect={() => navigate('/social-accounts')} />
                      ) : (<>

                      {/* Platform filter — click an icon to show ONLY that
                          platform's accounts; click it again (or "All") to reset. */}
                      {listAccounts.length > 0 && (() => {
                        // linkedin_page shares the linkedin icon, so group them.
                        const typeKey = (t) => (t === 'linkedin_page' ? 'linkedin' : t);
                        const types = [...new Set(listAccounts.map(a => typeKey(a.type)))];
                        if (types.length < 2) return null;
                        return (
                          <div className="d-flex align-items-center flex-wrap" style={{ gap: 6, marginBottom: 10 }}>
                            <button
                              type="button"
                              onClick={() => setTypeFilter('')}
                              title="Show all accounts"
                              style={{
                                border: typeFilter === '' ? '1px solid #c7d7fd' : '1px solid #e2e8f0',
                                background: typeFilter === '' ? '#eff6ff' : '#fff',
                                color: typeFilter === '' ? '#4f46e5' : '#64748b',
                                borderRadius: 8,
                                padding: '4px 9px',
                                cursor: 'pointer',
                                fontSize: '0.75rem',
                                fontWeight: 700,
                                lineHeight: '22px',
                              }}
                            >
                              All
                            </button>
                            {types.map(t => {
                              const active = typeFilter === t;
                              const count = listAccounts.filter(a => typeKey(a.type) === t).length;
                              return (
                                <button
                                  key={t}
                                  type="button"
                                  onClick={() => setTypeFilter(active ? '' : t)}
                                  title={active ? 'Show all accounts' : `Show only ${t} accounts (${count})`}
                                  style={{
                                    border: active ? '1px solid #4f46e5' : '1px solid #e2e8f0',
                                    background: active ? '#eff6ff' : '#fff',
                                    borderRadius: 8,
                                    padding: 4,
                                    cursor: 'pointer',
                                    lineHeight: 0,
                                    opacity: typeFilter && !active ? 0.45 : 1,
                                    filter: typeFilter && !active ? 'grayscale(1)' : 'none',
                                    boxShadow: active ? '0 0 0 2px #c7d2fe' : 'none',
                                    transition: 'opacity 0.15s, filter 0.15s, box-shadow 0.15s',
                                  }}
                                >
                                  <img src={platformIcons[t]} alt={t} style={{ width: 22, height: 22 }} />
                                </button>
                              );
                            })}
                          </div>
                        );
                      })()}

                      {listAccounts.length === 0 ? (
                        <p className="text-muted mb-0" style={{ fontSize: '0.875rem' }}>
                          There are no connected accounts yet.
                        </p>
                      ) : (
                        <div style={{ maxHeight: 320, overflowY: 'auto', overflowX: 'hidden' }}>
                          {listAccounts
                            .filter(a => !typeFilter || (a.type === 'linkedin_page' ? 'linkedin' : a.type) === typeFilter)
                            .map((account) => {
                            const accountValue = `${account.id}_${account.type}`;
                            const isSelected = selectedAccounts.includes(accountValue);

                            const handleCheckboxChange = (event) => {
                              const { checked, value } = event.target;
                              setSelectedAccounts((prevSelected) =>
                                checked
                                  ? [...prevSelected, value]
                                  : prevSelected.filter((item) => item !== value)
                              );
                            };

                            return (
                              <label
                                key={accountValue}
                                htmlFor={`account-${accountValue}`}
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 10,
                                  borderRadius: 8,
                                  padding: '8px 10px',
                                  marginBottom: 4,
                                  cursor: 'pointer',
                                  background: isSelected ? '#eff6ff' : 'transparent',
                                  border: isSelected ? '1px solid #c7d7fd' : '1px solid transparent',
                                  transition: 'background 0.15s, border 0.15s',
                                }}
                              >
                                {/* Platform icon + avatar stacked */}
                                <div className="position-relative flex-shrink-0">
                                  <AccountAvatar src={account.image} name={account.name} size={36} />
                                  {platformIcons[account.type] && (
                                    <div className="position-absolute" style={{ bottom: -2, right: -2 }}>
                                      <img
                                        src={platformIcons[account.type]}
                                        alt={account.type}
                                        style={{ height: 16, width: 16, borderRadius: '50%', background: '#fff', padding: 1 }}
                                      />
                                    </div>
                                  )}
                                </div>

                                {/* Name + type */}
                                <div style={{ flex: 1, minWidth: 0 }}>
                                  <div style={{ fontWeight: 600, fontSize: '0.875rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {account.name}
                                  </div>
                                  <div style={{ fontSize: '0.72rem', color: '#94a3b8', textTransform: 'capitalize' }}>
                                    {account.type === 'linkedin_page' ? 'LinkedIn Page' : account.type}
                                  </div>
                                </div>

                                {/* Checkbox */}
                                <input
                                  id={`account-${accountValue}`}
                                  type="checkbox"
                                  value={accountValue}
                                  checked={isSelected}
                                  onChange={handleCheckboxChange}
                                  style={{ width: 16, height: 16, flexShrink: 0, cursor: 'pointer' }}
                                />
                              </label>
                            );
                          })}
                        </div>
                      )}
                      </>)}
                    </div>

                    {/* Date / Timezone / Status */}
                    <div className="px-3 pb-3">
                      <div className="mb-3">
                        <label style={sectionLabelStyle}>Scheduled Date</label>
                        <DatePicker
                          selected={selectedDate}
                          onChange={handleDateChange}
                          showTimeSelect
                          timeIntervals={10}
                          timeCaption="Time"
                          dateFormat="MMMM d, yyyy h:mm aa"
                          className="form-control"
                          wrapperClassName="w-100"
                        />
                      </div>

                      <div className="mb-3">
                        <TimezoneSelector
                          value={timezone}
                          onChange={setTimezone}
                          label="Scheduling Timezone"
                        />
                      </div>

                      <div className="mb-2">
                        <label style={sectionLabelStyle}>Post Status</label>
                        <select
                          className="form-select form-control"
                          value={postStatus}
                          onChange={(e) => setPostStatus(e.target.value)}
                        >
                          <option value="publish">Ready to Publish / Scheduled</option>
                          <option value="draft">Draft (Stay in Drafts list)</option>
                          {postStatus === 'pending_approval' && (
                            <option value="pending_approval">Pending Approval</option>
                          )}
                        </select>
                        <small className="text-muted">
                          Set to draft if you&apos;re not ready to schedule this yet.
                        </small>
                      </div>

                      {/* ── Client Approval Toggle ── */}
                      {post.posted !== 1 && (
                        <div style={{ marginTop: 14, padding: '12px 14px', background: '#f8fafc', borderRadius: 10, border: '1px solid #e2e8f0' }}>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div>
                              <div style={{ fontWeight: 600, fontSize: '0.85rem', color: '#1e293b' }}>Require Client Approval</div>
                              <div style={{ fontSize: '0.72rem', color: '#94a3b8', marginTop: 2 }}>Send to client for review before publishing</div>
                            </div>
                            <div
                              onClick={() => setRequireApproval(v => !v)}
                              style={{
                                width: 44, height: 24, borderRadius: 12, flexShrink: 0, cursor: 'pointer',
                                background: requireApproval ? '#7c3aed' : '#cbd5e1',
                                position: 'relative', transition: 'background 0.2s',
                              }}
                            >
                              <div style={{
                                position: 'absolute', top: 3, left: requireApproval ? 23 : 3,
                                width: 18, height: 18, borderRadius: '50%', background: '#fff',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.2)', transition: 'left 0.2s',
                              }} />
                            </div>
                          </div>

                          {requireApproval && (
                            <div style={{ marginTop: 12, position: 'relative' }}>
                              <label style={{ fontSize: '0.78rem', fontWeight: 600, color: '#475569', marginBottom: 4, display: 'block' }}>
                                Client Email
                              </label>
                              <input
                                type="email"
                                value={approvalEmail}
                                onChange={e => handleApprovalEmailChange(e.target.value)}
                                onFocus={() => approvalEmail.length >= 2 && fetchEmailSuggestions(approvalEmail)}
                                onBlur={() => setTimeout(() => setShowEmailSuggestions(false), 150)}
                                placeholder="client@example.com"
                                style={{
                                  width: '100%', padding: '8px 10px', borderRadius: 8,
                                  border: '1px solid #e2e8f0', fontSize: '0.85rem',
                                  outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit',
                                }}
                              />
                              {showEmailSuggestions && emailSuggestions.length > 0 && (
                                <div style={{
                                  position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 999,
                                  background: '#fff', border: '1px solid #e2e8f0', borderRadius: 8,
                                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)', marginTop: 2, overflow: 'hidden',
                                }}>
                                  {emailSuggestions.map((s, i) => (
                                    <div
                                      key={i}
                                      onMouseDown={() => { setApprovalEmail(s); setShowEmailSuggestions(false); }}
                                      style={{
                                        padding: '8px 12px', fontSize: '0.83rem', cursor: 'pointer',
                                        color: '#1e293b', borderBottom: i < emailSuggestions.length - 1 ? '1px solid #f1f5f9' : 'none',
                                      }}
                                      onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                                      onMouseLeave={e => e.currentTarget.style.background = '#fff'}
                                    >
                                      {s}
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                    {/* Action footer */}
                    <div style={{ background: '#f8fafc', borderTop: '1px solid #e8edf2', borderRadius: '0 0 12px 12px', padding: '12px 16px' }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <button
                          type="button"
                          className="btn btn-link text-danger p-0"
                          style={{ textDecoration: 'none', fontSize: '0.875rem' }}
                          onClick={() => setShowTrashModal(true)}
                        >
                          Move to Trash
                        </button>

                        {post.posted == 1 ? (
                          <span style={{ fontSize: '0.78rem', fontWeight: 700, padding: '4px 12px', borderRadius: 20, background: '#f1f5f9', color: '#64748b' }}>
                            Already Published
                          </span>
                        ) : requireApproval ? (
                          <button
                            onClick={handleSendForApproval}
                            disabled={loading2}
                            style={{ background: '#7c3aed', border: 'none', color: '#fff', borderRadius: 8, padding: '7px 18px', fontWeight: 600, fontSize: '0.875rem', display: 'flex', alignItems: 'center', gap: 6, opacity: loading2 ? 0.7 : 1, cursor: loading2 ? 'not-allowed' : 'pointer' }}
                          >
                            {loading2 && <LoadingIndicator size={16} />}
                            ✉ Send for Approval
                          </button>
                        ) : (
                          <button
                            onClick={() => updateMyPost()}
                            style={{ background: '#4f46e5', border: 'none', color: '#fff', borderRadius: 8, padding: '7px 18px', fontWeight: 600, fontSize: '0.875rem', display: 'flex', alignItems: 'center', gap: 6 }}
                          >
                            {loading2 && <LoadingIndicator size={16} />}
                            Save Changes
                          </button>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Trash modal */}
                  <Modal show={showTrashModal} onHide={() => setShowTrashModal(false)} centered>
                    <Modal.Header closeButton>
                      <Modal.Title>Move to Trash?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      Are you sure you want to move this post to the trash? This will remove it from the schedule.
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={() => setShowTrashModal(false)}>
                        Cancel
                      </Button>
                      <Button variant="danger" onClick={handleMoveToTrash} disabled={isTrashing}>
                        {isTrashing ? <Spinner size="sm" /> : 'Yes, Move to Trash'}
                      </Button>
                    </Modal.Footer>
                  </Modal>

                  {/* Post analytics panel */}
                  <PostStats postId={postId} />

                </div>

                {/* ── Col 3: Preview ── */}
                <div className="col-12 col-md-4">
                  <PostPreview
                    content={content}
                    uploadedImages={uploadedImages}
                    uploadedVideos={uploadedVideos}
                    shortText={shortText}
                    title={isSkoolPost ? skoolTitle : ''}
                  />
                </div>

              </div>
            </div>
          )}
        </>
      )}
    </MainStructure>
  );
}

export default SinglePost;
